import moment from 'moment'

const Period = function (secondsBeforeNow) {
  if (isNaN(secondsBeforeNow) || !secondsBeforeNow) return ''

  return moment().subtract(secondsBeforeNow, 'seconds').fromNow()
}

export default Period
